export default __webpack_public_path__ + "static/media/Ankit_Tomar (3).f55c48f1.png";